var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCristal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.2 143.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#4b9cff}.cls-2,.cls-3,.cls-4,.cls-6{fill-rule:evenodd}.cls-3{fill:#d7f1ff;mix-blend-mode:overlay;opacity:.5}.cls-4,.cls-6{opacity:.45;fill:#5c7784;mix-blend-mode:multiply}.cls-6{opacity:.6}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cristaux"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m85 10-8 57-1 2v4l-1 3-6 43-1 9-2 13-10-5-11-5-5-2-3-2-7-3-7-3 1-3 2-13 1-4 10-45 4-21 1-3L75 3l1-1 2-1V0l7 10z",
    className: "cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m78 1-2 2-1 2-17 33-17-3 1-3L75 3l1-1 2-1z",
    className: "cls-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40 129-17-8 18-86 17 3-18 91z",
    className: "cls-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m66 141-26-12-17-8 1-3 24-27 21 28-3 22z",
    className: "cls-6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57 136h-1l-11-1H32l-16-1-1-3v-2L1 54l18-38v-1l9 6 9 35 9 37 1 2v3l2 8 3 9v2l1 1 4 18z",
    className: "cls-2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m19 16-3 38-15 3v-3l18-38z",
    className: "cls-3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m32 135-16-1-1-3v-2L1 57l15-3 9 47 1 4 2 8 2 9v2l2 11z",
    className: "cls-4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57 136h-1l-11-1H32l-16-1-1-3 1-2 9-28 1-1 1 1 7 5 8 4 2 1v1l6 4 2 1 1 1 4 18z",
    className: "cls-6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m85 64-2 31-13 36-4 12-24-5-2-3v-2l-3-5v-1l-1-2-1-2 1-2 3-8 2-3v-2l4-8 2-4v-1l2-4v-1l6-13v-2l15-6 6-2h1l8-3z",
    className: "cls-2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m85 64-9 9-1 1-8 8h-1l-1-1-10-4v-2l15-6 6-2h1l8-3z",
    className: "cls-3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m67 82-9 21-4 8-2 5-6 14-2 3-2 5-2-5-4-8-1-2 1-2 3-8 2-5 4-8 2-4 2-6 6-13 10 4 2 1z",
    className: "cls-4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m70 131-4 12-24-5-2-3v-2l-3-5v-1l-1-2-1-2 1-2 5-3h1l5-3 1-1h2l1-1 3-2 2-1 11 17 1 1 2 3z",
    className: "cls-6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m67 143-44-1h-1l-22-1 10-12 4-2 4-2 6-4v1l6 3 6 3h1a1329 1329 0 0 1 30 15Z",
    className: "cls-2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m24 122-1 10-13-3 14-8v1Z",
    className: "cls-3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23 142h-1l-22-1 10-12 5 1h1l7 2v10Z",
    className: "cls-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m85 64-2 31-13 36-4 12h1l-44-1h-1l1-1a256 256 0 0 0 14-14 180 180 0 0 0 19-25 130 130 0 0 0 14-33c8-26 5-48 6-66V2l2-1V0l7 10-8 57 8-3Z",
    style: {
      opacity: 0.3,
      fill: "#5c7784",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCristal);
export default __webpack_public_path__ + "static/media/cristal.bed48085daa8741db7b8b4a6002678a6.svg";
export { ForwardRef as ReactComponent };